import { t } from 'ttag'

const initialState = {
  jobZoneValues: {
    1: {
      id: 1,
      name: t`Job Zone One: Little or No Preparation Needed`,
      description: t`Some of these occupations may require a high school diploma or GED certificate.`
    },
    2: {
      id: 2,
      name: t`Job Zone Two: Some Preparation Needed`,
      description: t`These occupations usually require a high school diploma.`
    },
    3: {
      id: 3,
      name: t`Job Zone Three: Medium Preparation Needed`,
      description: t`Most occupations in this zone require training in vocational schools, related on-the-job experience, or an associate's degree.`
    },
    4: {
      id: 4,
      name: t`Job Zone Four: Considerable Preparation Needed`,
      description: t`Most of these occupations require a four-year bachelor's degree, but some do not.`
    },
    5: {
      id: 5,
      name: t`Job Zone Five: Extensive Preparation Needed`,
      description: t`Most of these occupations require graduate school. For example, they may require a master's degree, and some require a Ph.D., M.D., or J.D. (law degree).`
    }
  }
}
const data = (state = initialState, action) => {
  switch (action) {
    default:
      return state
  }
}

export default data
